import type { Maybe } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import type { PartialEntityData } from '@adornis/baseql/entities/types.js';
import type { SupportedFileType } from '@adornis/digitale-helden-shared/features/mediaverwaltung/client/las-file-explorer.js';
import { AdornisFilter } from '@adornis/filter/AdornisFilter.js';

@Entity()
export class FileFilter extends AdornisFilter {
  static override _class = 'FileFilter';

  constructor(data: PartialEntityData<FileFilter>) {
    super(data);
  }

  @Field(type => String) fileName: Maybe<string>;
  @Field(type => [String]) fileExtensions: Maybe<Array<SupportedFileType>>;
  @Field(type => String) md5: Maybe<string>;
  @Field(type => String) parentFolderID: Maybe<string>;
}
